import { type CountryCode } from '@webapp/core/entities/external/Country'
import {
  type PaymentMethodType,
  PaymentMethodTypes,
} from '@webapp/models/enums'
import messages from './messages'
import { useProcurifyIntl } from '../useProcurifyIntl'

export function useFormatPaymentMethodType() {
  const intl = useProcurifyIntl()

  return (
    paymentMethodType: PaymentMethodType,
    bankAccountCountryCode?: CountryCode,
    paymentRail?: string
  ): string => {
    switch (paymentMethodType) {
      case PaymentMethodTypes.OTHER:
      case PaymentMethodTypes.CHECK:
      case PaymentMethodTypes.ACH:
        return intl.formatMessage(messages.externalLabel)
      case PaymentMethodTypes.EFT:
      case PaymentMethodTypes.WIRE:
      case PaymentMethodTypes.PROCURIFY_WIRE:
      case PaymentMethodTypes.PROCURIFY_CHECK:
      case PaymentMethodTypes.PROCURIFY_ACH:
      case PaymentMethodTypes.AIRWALLEX:
        return `${bankAccountCountryCode} ${paymentRail?.split('_').join(' ')}`
      default:
        return null
    }
  }
}
